import BaseLayout from '@/components/PageLayout';
import '@elem/compBlog/blog.scss';
import BlogCategoryItems from '@elem/compBlog/category';
import SeoCommon from 'lowcode/common/SeoCommon';
import { queryBlogTagList, queryCategoryItems } from 'lowcomp/plugins/blog/common/blog-api/queryCategoryItems';

export default function Page({ categoryId, categoryData, categoryTagList }: any) {
    return (
        <BaseLayout>
            <SeoCommon title={categoryData.categoryName} description={categoryData.categoryName} />
            <BlogCategoryItems categoryId={categoryId} categoryData={categoryData} categoryTagList={categoryTagList} />
        </BaseLayout>
    );
}

export async function getServerSideProps({ params, locale }: any) {
    const categoryId = params.id;
    const categoryData = await queryCategoryItems(locale, {
        categoryId: categoryId[0],
        page: categoryId[2] || 1,
        size: 12,
    });
    const data = await queryBlogTagList(locale, {});
    const categoryTagList = data?.items || [];

    return {
        props: {
            locale,
            categoryId,
            categoryData,
            categoryTagList,
        },
    };
}
